
import { Component, Prop, Vue } from 'vue-property-decorator';
import WebsiteGroupRepositoryInterface, { WebsiteGroupItem } from '@/services/WebsiteGroup/interfaces';
import WebsiteRepositoryInterface from '@/services/Website/interfaces';
import { ServerRepositoryInterface } from '@/services/Server/Interfaces';

@Component({
  inject: [
    'websiteGroupRepository',
    'websiteRepository',
    'serverRepository',
  ],
})
export default class WebsiteGroupPicker extends Vue {
  @Prop({ default: 0, required: false, type: Number }) public value!: number | null;

  @Prop() public selectedServer!: string;

  public ownerFilterValue: string | null = '';

  private websiteGroupRepository!: WebsiteGroupRepositoryInterface;

  private websiteRepository!: WebsiteRepositoryInterface;

  private serverRepository!: ServerRepositoryInterface;

  public websiteGroupsLoading = false;

  public websiteGroups: WebsiteGroupItem[] = [];

  private websiteToDomain: Record<number, string> = {};

  private websitesServers: { [key: number]: string } = {};
  private serversHostnames: { [key: string]: string } = {};


  public async created(): Promise<void> {
    await this.initialize(this.ownerFilterValue);
  }

  public provideText(websiteGroupItem: WebsiteGroupItem | undefined): string {
    if (websiteGroupItem === undefined) {
      return '';
    }

    const output = this.websiteToDomain[websiteGroupItem.mainWebsite] ?? '';

    const serverId = this.websitesServers[websiteGroupItem.mainWebsite];
    if (!serverId) {
      return output;
    }

    const serverHostname = this.serversHostnames[serverId];
    if (!serverHostname) {
      return output;
    }

    return `${output} @ ${serverHostname}`;
  }


  public get ownerFilter(): string | null {
    return this.ownerFilterValue;
  }

  public set ownerFilter(value: string | null) {
    this.initialize(value)
  }

  public async initialize(val: string | null) {
    if (this.ownerFilterValue === val) return;
    this.ownerFilterValue = val;

    this.websiteGroupsLoading = true;

    const groupsResponse = await this.websiteGroupRepository.searchGroups(undefined, this.ownerFilterValue);

    this.websiteToDomain = {};
    if (!groupsResponse.groups.length) {
      this.websiteGroups = groupsResponse.groups;
      this.websiteGroupsLoading = false;

      return;
    }

    const mainWebsitesIds = groupsResponse.groups.map((group) => group.mainWebsite);
    const mainWebsites = await this.websiteRepository.getWebsitesByIds(mainWebsitesIds);

    const serversIds: string[] = [];
    mainWebsites.forEach((website) => {
      this.websiteToDomain[website.id] = website.domain;
      this.websitesServers[website.id] = website.originServer;

      if (serversIds.includes(website.originServer)) {
        return;
      }

      serversIds.push(website.originServer);
    });

    const servers = await this.serverRepository.getServersByIds(serversIds);
    servers.forEach((server) => {
      this.serversHostnames[server._id] = server.hostname;
    });

    this.websiteGroups = groupsResponse.groups;
    this.websiteGroupsLoading = false;
  }

  public checkDisabledGroup(group: WebsiteGroupItem): boolean {
    return this.websitesServers[group.mainWebsite] !== this.selectedServer
  }

  get groupId(): number | null {
    return this.value;
  }

  set groupId(value: number | null) {
    this.$emit('input', value);
  }
}
